type FeatureListProps = {
  values?: any;
  setEditTool?: any;
  customHelpers?: any;
  edit: boolean;
};
export const FeaturesList = ({ values, setEditTool, customHelpers, edit }: FeatureListProps) => {
  return (
    <div className="card">
      <div className="d-flex justify-content-between align-items-center card-header">
        <h6 className="mb-0 fs-lg ">Features List</h6>
      </div>
      {values?.tools?.map((item: any, index: number) => {
        return (
          <div className="card-body" key={item.title}>
            <div className="featuresBox d-flex mb-4">
              <div className="listCol h-100">
                <h3 className="title mb-0">
                  <span className="icon">
                    <img src={item.dummyImage || item.icon} width="15px" height="15px" alt="Icon" />
                  </span>
                  <span>{item.title}</span>

                  <span className="notificationDot" style={{ background: `${item.color}` }}></span>
                </h3>
                {item.features.map((items: any) => {
                  return (
                    <div className="listRow d-flex" key={items.title}>
                      <div className="content">
                        <div className="h-100">
                          <p className="mb-1">
                            <strong>{items.title}</strong>
                          </p>
                          <p>{items.description}</p>
                        </div>
                      </div>
                      <div className="imgCol text-center">
                        <div className=" h-100 d-flex align-items-center justify-content-center">
                          <img src={items.dummyImage || items.image} alt="Image" />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="actionCol">
                <div className="d-flex align-items-center justify-content-center flex-column h-100">
                  <a onClick={() => edit && customHelpers.remove(index)} className="mx-1 my-2 cursor-pointer text-darkblue">
                    <i className="fa-regular fa-trash-can"></i>
                  </a>

                  <a onClick={() => edit && setEditTool({ tool: item, index })} className="mx-1 my-2 cursor-pointer text-darkblue">
                    <i className="fa-regular fa-pen-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
